// extracted by mini-css-extract-plugin
module.exports = {"lenkepanel":"Omradekort_lenkepanel__1rlPi","lenkebase":"Omradekort_lenkebase__aWpWj","titleShort":"Omradekort_titleShort__2nrxY","titleLong":"Omradekort_titleLong__oh9rl"};